import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";

export const UpdatePersonMemberMetaFields = {
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  dob: propertyMeta("dob", false, false, false, MetaTypesBase.LocalDate),
  gender: propertyMeta("gender", false, false, false, MetaTypesBase.string),
  ethnicity: propertyMeta("ethnicity", false, false, false, MetaTypesBase.string),
  language: propertyMeta("language", false, false, false, MetaTypesBase.string),
  school: propertyMeta("school", false, false, false, MetaTypesBase.string),
  swimProof: propertyMeta("swimProof", false, false, false, MetaTypesBase.number),
  sailingExp: propertyMeta("sailingExp", false, false, false, MetaTypesBase.string),
  allergies: propertyMeta("allergies", false, false, false, MetaTypesBase.string),
  medications: propertyMeta("medications", false, false, false, MetaTypesBase.string),
  specialNeeds: propertyMeta("specialNeeds", false, false, false, MetaTypesBase.string),
  employer: propertyMeta("employer", false, false, false, MetaTypesBase.string),
  occupation: propertyMeta("occupation", false, false, false, MetaTypesBase.string),
  matchingGifts: propertyMeta("matchingGifts", false, false, false, MetaTypesBase.string),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta("preferred", false, false, false, MetaTypesBase.string),
  personIdDidSet: propertyMeta("personIdDidSet", false, true, false, MetaTypesBase.boolean),
  emailDidSet: propertyMeta("emailDidSet", false, true, false, MetaTypesBase.boolean),
  dobDidSet: propertyMeta("dobDidSet", false, true, false, MetaTypesBase.boolean),
  genderDidSet: propertyMeta("genderDidSet", false, true, false, MetaTypesBase.boolean),
  ethnicityDidSet: propertyMeta("ethnicityDidSet", false, true, false, MetaTypesBase.boolean),
  languageDidSet: propertyMeta("languageDidSet", false, true, false, MetaTypesBase.boolean),
  schoolDidSet: propertyMeta("schoolDidSet", false, true, false, MetaTypesBase.boolean),
  swimProofDidSet: propertyMeta("swimProofDidSet", false, true, false, MetaTypesBase.boolean),
  sailingExpDidSet: propertyMeta("sailingExpDidSet", false, true, false, MetaTypesBase.boolean),
  allergiesDidSet: propertyMeta("allergiesDidSet", false, true, false, MetaTypesBase.boolean),
  medicationsDidSet: propertyMeta("medicationsDidSet", false, true, false, MetaTypesBase.boolean),
  specialNeedsDidSet: propertyMeta("specialNeedsDidSet", false, true, false, MetaTypesBase.boolean),
  employerDidSet: propertyMeta("employerDidSet", false, true, false, MetaTypesBase.boolean),
  occupationDidSet: propertyMeta("occupationDidSet", false, true, false, MetaTypesBase.boolean),
  matchingGiftsDidSet: propertyMeta("matchingGiftsDidSet", false, true, false, MetaTypesBase.boolean),
  createdOnDidSet: propertyMeta("createdOnDidSet", false, true, false, MetaTypesBase.boolean),
  createdByDidSet: propertyMeta("createdByDidSet", false, true, false, MetaTypesBase.boolean),
  updatedOnDidSet: propertyMeta("updatedOnDidSet", false, true, false, MetaTypesBase.boolean),
  updatedByDidSet: propertyMeta("updatedByDidSet", false, true, false, MetaTypesBase.boolean),
  prefixDidSet: propertyMeta("prefixDidSet", false, true, false, MetaTypesBase.boolean),
  firstDidSet: propertyMeta("firstDidSet", false, true, false, MetaTypesBase.boolean),
  middleDidSet: propertyMeta("middleDidSet", false, true, false, MetaTypesBase.boolean),
  lastDidSet: propertyMeta("lastDidSet", false, true, false, MetaTypesBase.boolean),
  suffixDidSet: propertyMeta("suffixDidSet", false, true, false, MetaTypesBase.boolean),
  preferredDidSet: propertyMeta("preferredDidSet", false, true, false, MetaTypesBase.boolean),
};

export const UpdatePersonMemberMeta = typeMeta("UpdatePersonMember", UpdatePersonMemberMetaFields);
